<template>
    <div class="content main-container">
        <div class="search-box gauge_20">
            <div class="input-item big-label">
                <span class="label">机构名称</span>
                <selectTree v-model="search.orgId" type="4" status="-1"></selectTree>
            </div>

            <div class="input-item big-label">
                <span class="label">生效时间</span>
                <DatePicker transfer v-model="dateVal" type="daterange" placement="bottom-end" placeholder="请选择">
                </DatePicker>
            </div>

            <div class="btn-item">
                <Button type="primary" @click="formSearch">查询</Button>
                <Button type="warning" @click="$refs.add.open({ id: $route.query.id })">新增</Button>
                <Button ghost type="primary" @click="pageBack">返回</Button>
            </div>
        </div>

        <div class="table-box">
            <loading :isShow="loading" />
            <Table :columns="columns" :data="tableList">
                <template slot-scope="{ row }" slot="orgName">
                    <span :class="row.orgStatus == 1 ? 'opening' : 'close'"></span>{{ row.orgName }}
                </template>
                <template slot-scope="{ row }" slot="startTime">
                    <span v-if="!row.edit" class="edit-box">{{ row.startTime |
                        filterTime('YYYY/MM/DD') }}</span>
                    <DatePicker v-else :disabled="row.status == 2 || row.status == 1" v-model="row.startTime" format="yyyy/MM/dd" type="date" :options="options"
                        placeholder="请选择" style="width: 120px" transfer />
                </template>
                <template slot-scope="{ row }" slot="endTime">
                    <span v-if="!row.edit" class="edit-box">{{ row.endTime |
                        filterTime('YYYY/MM/DD') }}</span>
                    <DatePicker v-else v-model="row.endTime" format="yyyy/MM/dd" type="date" :options="options"
                        placeholder="请选择" style="width: 120px" transfer />
                </template>
                <template slot-scope="{ row,index }" slot="action">
                    <!-- 0-可操作 1-已过生效期 2-已过期 -->
                    <span v-if="!row.edit" class="table-btn" @click="edit(true, row, index)"
                        :class="{ 'disabled': row.status == 2 || row.orgStatus != 1 }">编辑</span>
                    <span v-if="row.edit" class="table-btn" @click="edit(false, row, index)">取消</span>
                    <span v-if="!row.edit" @click="remove(row)" class="table-btn"
                        :class="{ 'disabled': row.orgStatus != 1 || row.status != 0 }">移除</span>
                    <span v-else class="table-btn" @click="editTime(row)">保存</span>
                </template>
            </Table>
        </div>
        <div class="pageBox">
            <Page :total="allData.total" :current="search.pageNo" :page-size="allData.size" show-total
                @on-change="pageChange" style="text-align: center" />
        </div>

        <!-- 新增 -->
        <add-basic-law ref="add" :initList="getBasicLawList"></add-basic-law>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import selectTree from '@/components/system/selectTree3';
import addBasicLaw from './components/addBasicLaw.vue';
import { common } from '@/api/mixins';
export default {
    mixins: [common],
    components: { selectTree, addBasicLaw },
    data() {
        return {
            options: {
                disabledDate(date) {
                    return dayjs(date).isBefore(new Date())
                }
            },
            dateVal: [],
            search: {
                baseId: '',//基本法id
                orgId: '', //适用机构
                pageNo: 1,
                pageSize: 10
            },
            baseInfo: {},
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            loading: false,
            columns: [
                {
                    title: '序号',
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '适用机构',
                    slot: 'orgName',//机构状态(1. 营业中 2. 已关闭)
                    minWidth: 200,
                    align: 'center'
                },
                {
                    title: '开始时间',
                    slot: 'startTime',
                    minWidth: 200,
                    align: 'center'
                },
                {
                    title: '结束时间',
                    slot: 'endTime',
                    minWidth: 200,
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',//0-可操作 1-已过生效期 2-已过期
                    width: 300,
                    align: 'center'
                }
            ],
            tableList: [],
            allData: {},
        };
    },

    created() {
        this.search.baseId = this.$route.query.id;
        this.getBasicLawList();
    },

    methods: {
        edit(val, row, index) {
            console.log(val, row, index)
            if (val) {
                this.baseInfo[row.id] = JSON.parse(JSON.stringify(row));
            } else {
                row.startTime = this.baseInfo[row.id].startTime;
                row.endTime = this.baseInfo[row.id].endTime;
            }
            row.edit = val;
        },
        remove(row) {
            this.$notice.inquiry('是否确认移除该机构？').then(() => {
                this.$http({
                    url: '/buz/baseAssign/del',
                    type: 'GET',
                    data: {
                        id: row.id
                    }
                })
                    .then(res => {
                        this.$Message.success('操作成功')
                        this.getBasicLawList()
                    })
            })
        },
        /**
         * 
         * @param {*} type 1开始日期 结束日期
         * @param {*} row 
         */
        editTime(row) {
            if (!row.startTime || !row.endTime) {
                return this.$Message.error(`开始时间、结束时间不能为空！`)
            }
            if (!dayjs(row.startTime).isBefore(row.endTime)) {
                return this.$Message.error(`结束时间需要大于开始时间`);
            }
            let data = {
                ...row,
                startTime: dayjs(row.startTime).format('YYYY-MM-DD'),
                endTime: dayjs(row.endTime).format('YYYY-MM-DD')
            }
            this.$notice.inquiry('是否确认修改？').then(() => {
                this.$http({
                    url: '/buz/baseAssign/edit',
                    type: 'POST',
                    data

                })
                    .then(res => {
                        row.edit = false
                        this.$Message.success('操作成功')
                    })
            })
        },
        // 基本法列表
        getBasicLawList(index) {
            if (index) {
                this.search.pageNo = index;
            }
            if (this.dateVal.length && this.dateVal[0]) {
                this.search.startTimeStart = dayjs(this.dateVal[0]).format('YYYY-MM-DD')
                this.search.startTimeEnd = dayjs(this.dateVal[1]).format('YYYY-MM-DD')
            } else {
                this.search.startTimeStart = ''
                this.search.startTimeEnd = ''
            }
            this.loading = true;
            this.$http({
                url: '/buz/baseAssign/read/list',
                type: 'POST',
                data: this.search

            })
                .then(res => {
                    this.loading = false;
                    this.allData = res;
                    this.tableList = res.data.map(item => {
                        item.edit = false;
                        return item
                    });
                })
                .catch(e => {
                    this.loading = false;
                });
        },

        // 查询
        formSearch() {
            this.getBasicLawList();
        },

        // 分页
        pageChange(index) {
            this.search.pageNo = index;
            this.getBasicLawList();
        },

        // 返回
        pageBack() {
            const fullPath = this.$route && this.$route.fullPath;
            window.parent.postMessage(
                {
                    removePageTag: fullPath,
                    appMessage: true
                },
                '*'
            );
            setTimeout(() => {
                this.openPageTabTags('/basicLawNew/config', {});
            }, 200);
        }
    }
};
</script>
<style lang="scss" scoped>
.disabled {
    pointer-events: none;
    color: #c5c8ce;
}

.close,
.opening {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
}


.close {
    background: #E36767;
}

.opening {
    background: #35BF3F;
}
</style>
